<!-- eslint-disable vue/no-unused-refs -->
<template>
  <text-item
    v-if="item.el === undefined || item.el === 'text'"
    :it="item"
    :model="model"
    class="text-item"
  />
  <form-item
    ref="formItem"
    v-else
    :it="item"
    :model="model"
    :labelWidth="labelWidth"
  >
    <span slot="labelTip" v-if="item.itemConfig.labelTip">
      <el-tooltip placement="top">
        <div slot="content" v-html="item.itemConfig.labelTip.content" />
        <i class="el-icon-warning" />
      </el-tooltip>
    </span>
  </form-item>
</template>

<script>
export default {
  name: 'FormTextGenerator',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    model: {
      type: Object,
      default: () => ({}),
    },
    labelWidth: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
}
</script>

<style scoped lang="scss">
.text-item {
  ::v-deep(.el-form-item__content) {
    display: flex;
  }
}
</style>
